module.exports = __webpack_public_path__ + "static/media/social-media.04aef0f0.svg";